export function formatDollars(value: number): string {
  const rounded = Math.round(value * 100) / 100;

  return rounded.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: rounded % 1 !== 0 ? 2 : 0,
  });
}

export function formatLargeDollars(value: number) {
  if (value >= 10e5) {
    return `${formatDollars(value / 10e5)}M`;
  }
  if (value >= 10e4) {
    return `${formatDollars(value / 10e2)}K`;
  }
  return `${formatDollars(value)}`;
}

export function formatPricePlusMinus(price: number, omitPlus = false) {
  let prefix = "";
  if (!omitPlus) {
    prefix = price < 0 ? "-" : "+";
  } else {
    prefix = price < 0 ? "-" : "";
  }

  return `${prefix}${formatDollars(Math.abs(price))}`;
}

/**
 * Format a number as USD currency without decimal places.
 * Useful for displaying whole dollar amounts like property prices.
 */
export function formatDollarsWholeNumber(value: number): string {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
}
